export interface ValidationInfo {
  message: string
  level: ErrorSeverity
  impactedFields: string[]
}
export interface BulkValidationResponse {
  validationMap: { [key: number]: ValidationInfo[] }
  commonValidations: ValidationInfo[]
}

export interface BulkErrorMapKey {
  rowId: number
  impactedField: string
}

export enum ErrorSeverity {
  WARN = 'WARN',
  ERROR = 'ERROR',
  FORBIDDEN = 'FORBIDDEN',
}

export enum RequestMode {
  NEW_TRAN = 'NEW_TRAN',
  ENTER_EXTERNAL_TRAN = 'ENTER_EXTERNAL_TRAN',
  EDIT_TRAN = 'EDIT_TRAN',
  NEW_TRAN_BULK = 'NEW_TRAN_BULK',
  ENTER_EXTERNAL_TRAN_BULK = 'ENTER_EXTERNAL_TRAN_BULK',
  EDIT_TRAN_BULK = 'EDIT_TRAN_BULK',
}

export interface MessageWithLevel {
  message: string
  level: ErrorSeverity
}
